import SearchIcon from "@mui/icons-material/Search";

import { InputAdornment } from "@/Components/v2/atoms/InputAdornment";
import { TextField } from "@/Components/v2/atoms/TextField";

interface SearchableSelectFieldProps {
  placeHolder: string;
  InputProps: any;
}

export const SearchableSelectField: React.FC<SearchableSelectFieldProps> = ({
  placeHolder,
  ...params // Assuming params are passed directly to the TextField component
}) => {
  return (
    <TextField
      {...params}
      placeholder={placeHolder}
      size="small"
      InputProps={{
        ...params.InputProps,
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchableSelectField;
